import React, { useEffect, useState } from "react";
import WellnessScorePrintPage from "../../components/WellnessScorePrint/WellnessScorePrintPage";
import { getSmartScanReportForExternalClient_Ajax } from "../../helpers/requests";
import { useDispatch, useSelector } from "react-redux";
import {
  hideLoadingSpinner,
  showLoadingSpinner
} from "../../redux/actions/loadingSpinner";
import { handleApiErrors, showAlertDialouge } from "../../helpers/utils";

const WellnessReportForExternalClient = ({ scrambledData }) => {
  const [currentScore, setCurrentScore] = useState();

  const [smartscanReportSummary, setSmartscanReportSummary] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    getSmartscanReportDetails();
  }, []);

  useEffect(() => {
    setCurrentWhitenessScore();
  }, [smartscanReportSummary]);

  const whitenessScoreAvailableForProviderIds = useSelector(
    (state) =>
      state?.appSettings?.settingsData
        ?.showWhitenessScoreInSmartScanReportForProviders
  );

  function getSmartscanReportDetails() {
    if (!scrambledData) {
      return;
    }

    let params = {
      scrambledData: scrambledData
    };

    dispatch(showLoadingSpinner());

    getSmartScanReportForExternalClient_Ajax(
      params,
      function (response) {
        dispatch(hideLoadingSpinner());
        if (response?.success && response?.data) {
          setSmartscanReportSummary(response.data);
        } else {
          showAlertDialouge("Message", response?.message);
        }
      },
      function (err) {
        dispatch(hideLoadingSpinner());
        handleApiErrors(err);
      }
    );
  }

  function setCurrentWhitenessScore() {
    if (
      !whitenessScoreAvailableForProviderIds?.includes(
        smartscanReportSummary?.providerId
      )
    ) {
      return;
    }

    if (
      !smartscanReportSummary?.whitenessScoresVM ||
      smartscanReportSummary?.whitenessScoresVM.length <= 0
    ) {
      return;
    }

    let score = smartscanReportSummary?.whitenessScoresVM.find((element) => {
      return (
        element.smartScanId == smartscanReportSummary?.smartScanVM?.smartScanId
      );
    })?.whitenessScore;

    setCurrentScore(score);
  }

  return (
    <div id={"external-client-smartscan-report"}>
      <section className="step-section py-1">
        <div className="container">
          <WellnessScorePrintPage
            smartScanCaseReport={smartscanReportSummary?.smartScanCaseReportVM}
            wellnessScoreSummary={
              smartscanReportSummary?.smartScanWellnessScoreSummary
            }
            smartScanId={smartscanReportSummary?.smartScanVM?.smartScanId}
            patientId={smartscanReportSummary?.smartScanVM?.patId}
            isForExternalClient={true}
            smartScanVM={smartscanReportSummary?.smartScanVM}
            whitenessScoresVM={smartscanReportSummary?.whitenessScoresVM}
            currentScore={currentScore}
          />
        </div>
      </section>
    </div>
  );
};

export default WellnessReportForExternalClient;
